import { CommonModule, DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { environment } from 'projects/shared/environments/environment';
import { LinksService } from 'projects/shared/services/links.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent, SwiperModule } from 'swiper/angular';
import { LightModeService } from '../../../+shared/services/light-mode.service';
import { FooterService } from './services/footer.service';
import { noop, Subscription, tap } from 'rxjs';
import { ILink } from 'projects/admin/src/app/components/panel/social-media/interface/social-media';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserService } from 'projects/shared/services/browser.service';
import { currentRouteLang } from 'projects/shared/utils/route-lang';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, SkeletonModule, SwiperModule, TranslateModule]
})
export class FooterComponent implements OnInit {
  email: string = 'sales@card4games.com';
  lightMood = false;

  paymentImages = [
    {
      src: '../../../../assets/images/footer/payment/visa.svg',
      alt: 'visa logo'
    },
    {
      src: '../../../../assets/images/footer/payment/master.svg',
      alt: 'master logo'
    },
    // {
    //   src: '../../../../assets/images/footer/payment/527px-PayPal_logo 1.svg',
    //   alt: 'paypal logo'
    // },
    // {
    //   src: '../../../../assets/images/footer/payment/web_money.svg',
    //   alt: 'web money logo'
    // },
  ];

  socialMediaLink = [
    {
      url: 'https://www.facebook.com/Card4GamesLTD',
      icon: 'pi pi-facebook'
    },
    {
      url: 'https://wa.link/sxc3ao',
      icon: 'pi pi-whatsapp'
    },
    {
      url: 'https://www.instagram.com/card4games/',
      icon: 'pi pi-instagram'
    },
  ]

  lang = ''

  URLApp = environment.apiUrl;
  logo = '../../../../assets/images/main/white 1.webp';

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 10,
    autoplay: {
      delay: 2000, // Autoplay delay in milliseconds
      disableOnInteraction: false // Ensures autoplay continues even after manual interaction
    },
    // loop: true,
    grabCursor: true,
    breakpoints: {
      350: {
        slidesPerView: 1.5,
        spaceBetween: 20
      },
      420: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      590: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 20
      },
      991: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1100: {
        slidesPerView: 2,
        spaceBetween: 20
      },
    }
  };

  _subscription = new Subscription();

  activeIndex: any;

  links!: ILink[];

  // ! On Scroll Load Data
  lastScroll = 0;
  isScrollingDown = false;
  @ViewChild('target', { static: true }) targetedElement!: ElementRef;

  constructor(
    private _Meta: Meta,
    private _TitleService: Title,
    private _Renderer: Renderer2,
    private _LinksService: LinksService,
    private lightModeService: LightModeService,
    private _footerService: FooterService,
    private _browserService: BrowserService,
    @Inject(PLATFORM_ID) private platformId: any, @Inject(DOCUMENT) private document: Document
  ) {
    const locationBr = this._browserService.getLocation();
    if (locationBr) {
      this.lang = location.pathname.split('/')[1]
    } else {
      this.lang = currentRouteLang();
    }
  }

  ngOnInit(): void {

    const localStorageBr = this._browserService.getLocalStorage();

    if (localStorageBr) {
      if (localStorage.getItem('lightMode') == 'false') {
        this.lightModeService.lightMood.next(false);
        this.lightMood = false;
      } else {
        this.lightModeService.lightMood.next(true);
        this.lightMood = true;
      }

    }

    if (this._browserService.getWindow()) this.onscrollDataLoader();
  }

  // ! <<<<<<<<<<<<<<<<   On Scroll Load Data   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  // ? Detect If User Scroll Down Not Up
  @HostListener('window:scroll', ['$event'])
  onScrollDown(event: any) {

    if (this._browserService.getWindow()) {
      const current = window.scrollY;

      // ? If This Variable == true; Then User Scrolling Down
      this.isScrollingDown = current > this.lastScroll;

      this.lastScroll = current;
    }
  }

  onscrollDataLoader() {
    // ? This Target Variable For Catch Item We Needed To Observe
    let target: any = this.targetedElement?.nativeElement;
    let targetAppeared = false;

    // ? The Observer
    const observer = new IntersectionObserver(([entry]) => {


      // ? This If Condition Run When Last Item Appeared On Display
      if (entry.isIntersecting && this.isScrollingDown) {
        targetAppeared = true;
        // ? Load Data
        this.getSocialMediaLinks()

        // ? This Disconnect For Remove Old Last Item From Observer
        observer.disconnect();
      }
    }, {
      threshold: 0.1 // ? 10% of element visible (change as needed)
    });

    // ? This Set Time Out For Witting To DOC Rendering
    setTimeout(() => {
      if (targetAppeared) {
        // ? Stop Observer
        observer.unobserve(target);
        // ? This Disconnect Is Increased Assurance Is No More
        observer.disconnect();
      } else {
        observer.observe(target);
      }

    }, 500);
  }


  getSocialMediaLinks() {
    this._subscription.add(
      this._footerService.getSocialMediaLinks().pipe(tap(
        links => {
          this.links = links.docs;
        }
      )).subscribe(noop)
    )
  }


  changeSiteMode() {
    const localStorageBr = this._browserService.getLocalStorage();

    if (localStorageBr) {
      this.lightModeService.lightMood.next(this.lightMood);
      if (this.lightMood) {
        localStorage.setItem('lightMode', 'true');
      } else {
        localStorage.setItem('lightMode', 'false');
      }

    }

  }

  onSwiper() {
    this.activeIndex = this.swiper?.swiperRef?.realIndex;
  }

  onSlideChange() {
    this.activeIndex = this.swiper?.swiperRef?.realIndex;
  }

  slideNext() {
    this.swiper?.swiperRef.slideNext(500, false);
  }

  slidePrev() {
    this.swiper?.swiperRef.slidePrev(500, false);
  }

  scrollUp(): void {
    const windowBr = this._browserService.getWindow();

    if (windowBr) {

      window.scrollTo(0, 0);
    }
  }

  updateMetaTags() {
    // Set the page title
    this._TitleService.setTitle('Footer | Card4Games - Your Trusted Gaming Partner');

    // Open Graph Meta Tags
    this._Meta.updateTag({
      property: 'og:title',
      content: 'Footer | Card4Games - Your Trusted Gaming Partner'
    });

    // Standard Meta Tags
    this._Meta.updateTag({
      name: 'description', content: 'Discover more about Card4Games, your trusted partner in gaming. Learn about our mission, values, and commitment to providing the best trading cards and gaming supplies.'
    });

    this._Meta.updateTag({
      name: 'keywords',
      content: 'Card4Games, About Us, gaming cards, trading cards, gaming supplies, mission, values'
    });

    this._Meta.updateTag({
      property: 'og:description',
      content: 'Learn about Card4Games, our dedication to gaming enthusiasts, and our range of high-quality trading cards and gaming accessories.'
    });

    this._Meta.updateTag({
      property: 'og:image',
      content: this.logo
    });

    this._Meta.updateTag({
      property: 'og:url',
      content: this._LinksService.URLApp
    });

    this._Meta.updateTag({
      property: 'og:type',
      content: 'website'
    });

  }

  addStructuredData() {
    // Structured data (Organization + WebSite + SiteNavigationElement) is handled
    // globally by AppComponent to avoid duplicate JSON-LD injection.
  }
}
